import { render, staticRenderFns } from "./Topbox.vue?vue&type=template&id=efe6e024&scoped=true&"
import script from "./Topbox.vue?vue&type=script&lang=js&"
export * from "./Topbox.vue?vue&type=script&lang=js&"
import style0 from "./Topbox.vue?vue&type=style&index=0&id=efe6e024&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe6e024",
  null
  
)

export default component.exports